<template>
  <page-outline :title="$t('tracking.tracks_details')">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    <template slot="secondaryActions">
      <app-button
        :text="$t('common.rfrsh')"
        icon="fa-light fa-rotate-right"
        variant="light"
        @click="getTrack()"
        :aria-label="$t('common.rfrsh')">
      </app-button>
    </template>
    <template slot="pageContent">
      <b-container fluid>
        <spinner v-if="activateSpinner"></spinner>
        <template v-else-if="Tracking">
          <div>
            <form-accordion :title="$t('tracking.testcases')" :isTitleUpperCase="false" v-if="flagTOOLBOX && Tracking.TestCasename">
              <b-row class="form-group">
                <b-col sm="6" class="mb-5">
                  <table 
                    class="table"
                    style="margin-bottom:0"
                    :aria-label="$t('tracking.testcase_details_label')">
                    <caption>{{ $t('tracking.testcase_details_caption') }}</caption>
                    <thead class="sr-only">
                      <tr>
                        <th scope="col">{{ $t('common.field') }}</th>
                        <th scope="col">{{ $t('common.value') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in TrackingTestCaseTableFormattedData" :key="item.field">
                        <th scope="row" class="text-left">{{ getFieldTrad(item.field) }}</th>
                        <td class="text-left">
                          <span v-if="item.field === 'CreationDateRq1'">{{ getDate(item.value) }}</span>
                          <span v-else>{{ item.value }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="flagTOOLBOX ? $t('tracking.details_request') : $t('tracking.details')" :isTitleUpperCase="false">
              <!-- {{Object.entries(Tracking).map(([key, value]) => ({'key':key,'value':value}))}} -->
              <b-row class="form-group"  v-if="flagTOOLBOX">
                <b-col sm="6" class="mb-5">
                  <b-table
                    class="table"
                    thead-class="d-none"
                    style="margin-bottom:0"
                    :fields="TOOLBOXTableFields"
                    :items="TrackingTableFormattedData"
                    :caption="$t('tracking.tracking_details_caption')"
                    caption-top
                    aria-label="Détails du suivi">
                    <template #cell(field)="data">
                      <span>{{ getFieldTrad(data.value) }}</span>
                    </template>
                    <template #cell(value)="data">
                      <span v-if="data.item.field === 'CreationDateRq1'">{{ getDate(data.value) }}</span>
                      <span v-else>{{ data.value }}</span>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row class="form-group" v-else>
                <b-col sm="4" class="mb-5" v-if="type === 'DDD'">
                  <form-read-group-label-input v-if="Tracking.Provider !== ''"
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.provider_ddd') : 'Provider'" :inputValue="Tracking.Provider == 1 ? 'STET' : 'EBA'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV' && !flagCACP">
                  <form-read-group-label-input v-if="Tracking.Provider !== ''"
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.provider_ddd') : 'Provider'" :inputValue="Tracking.Provider == 1 ? 'STET' : 'EBA'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="Tracking.MsgId !== ''"
                    :inputLabel="getInputLabel()" :inputValue="Tracking.MsgId">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="getInputLabel()" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV' && !flagCACP">
                  <form-read-group-label-input v-if="Tracking.IBAN !== ''"
                    :inputLabel="$t('tracking.iban')" :inputValue="Tracking.IBAN">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV'">
                  <form-read-group-label-input v-if="Tracking.FileSubmissionId !== ''"
                    :inputLabel="$t('tracking.flagCACP.file_submission_id')" :inputValue="Tracking.FileSubmissionId">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('tracking.flagCACP.file_submission_id')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" v-if="type != 'DDD' && flagCACP" class="mb-5">
                  <form-read-group-label-input v-if="Tracking.BICFrom != ''"
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.bic_from_ddd') :$t('tracking.bic_from')" :inputValue="Tracking.BICFrom">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.bic_from_ddd') :$t('tracking.bic_from')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="Tracking.BICBillable !== '' && Tracking.BICFrom !== Tracking.BICBillable && Tracking.BICFrom !== ''"
                    :inputLabel="$t('tracking.bic_billable')" :inputValue="Tracking.BICBillable">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('tracking.bic_billable')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="Tracking.BICTo !== ''"
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.bic_to_ddd') :$t('tracking.bic_to')" :inputValue="Tracking.BICTo">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.bic_to_ddd') :$t('tracking.bic_to')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV'">
                  <form-read-group-label-input v-if="Tracking.IBAN !== ''"
                    :inputLabel="flagCACP ? $t('tracking.flagCACP.beneficiary_bank_country') : $t('administration.country')" :inputValue="getCountryFromIBAN(Tracking.IBAN)">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="flagCACP ? $t('tracking.flagCACP.beneficiary_bank_country') : $t('administration.country')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.FullName !== '' && type === 'DDV' && !flagCACP">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.name')" :inputValue="Tracking.FullName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Siren !== '' && type === 'DDV' && !flagCACP">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.siren')" :inputValue="Tracking.Siren">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Siret !== '' && type === 'DDV' && !flagCACP">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.siret')" :inputValue="Tracking.Siret">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.TVAIntracomm !== '' && type === 'DDV' && !flagCACP">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.tva_intracomm')" :inputValue="Tracking.TVAIntracomm">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.LEI !== '' && type === 'DDV' && !flagCACP">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.select.identifiers.LEIC.label')" :inputValue="Tracking.LEI">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.EUID !== '' && type === 'DDV' && !flagCACP">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.select.identifiers.EUID.label')" :inputValue="Tracking.EUID">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.ICQX !== '' && type === 'DDV' && !flagCACP">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.icqx')" :inputValue="Tracking.ICQX">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV' && flagCACP">
                  <form-read-group-label-input v-if="Tracking.Provider !== ''"
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.provider_ddd') : 'Provider'" :inputValue="Tracking.Provider == 1 ? 'STET' : 'EBA'">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.provider_ddd') : 'Provider'" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV'">
                  <form-read-group-label-input v-if="Tracking.Reference !== ''"
                      :inputLabel="flagCACP ? $t('tracking.flagCACP.msg_id_request_provider') : $t('tracking.reference')" :inputValue="Tracking.Reference">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="flagCACP ? $t('tracking.flagCACP.msg_id_request_provider') : $t('tracking.reference')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.AdditionalInformation !== '' && type === 'DDV'">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.additional_information')" :inputValue="Tracking.AdditionalInformation">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.CreationDateRq1 !== ''">
                  <form-read-group-label-input
                                               :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.creation_date_request_1_ddd') : $t('tracking.creation_date_request_1')" :inputValue="getDate(Tracking.CreationDateRq1)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Request2CreationDate !== '' && type != 'DDD' && flagCACP">
                  <form-read-group-label-input
                                               :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.creation_date_request_2_ddd') :$t('tracking.creation_date_request_2')" :inputValue="getDate(Tracking.Request2CreationDate)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.CreationDateRq1 !== '' && Tracking.CreationDateRp2 !== '' && (type === 'DDD'&& flagCACP)">
                  <form-read-group-label-input
                                               :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.response_time_ddd') :$t('common.response_time')" :inputValue="getDuration(Tracking)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Tracking !== '' && (type === 'DDD'&& flagCACP)">
                  <form-read-group-label-input
                                               :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.technical_code_ddd') :$t('tracking.technical_code')" :inputValue="Tracking.TechStatusCode !== '' ? translateTechStatusCode(Tracking.TechStatusCode) : $t('common.monitoring.success')">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDD'&& flagCACP">
                  <form-read-group-label-input
                                               :inputLabel="$t('tracking.result_ddd')" :inputValue="getResultDDD(Tracking)">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <hr  class="mx-auto" />
            <form-accordion :title="$t('tracking.response')" :isTitleUpperCase="false">
              <b-row v-if="flagTOOLBOX">
                <b-col sm="6" class="mb-5">
                  <b-table
                    class="table"
                    thead-class="d-none"
                    style="margin-bottom:0"
                    :fields="TOOLBOXTableFields"
                    :items="TrackingTableRespFormattedData">
                    <template #cell(field)="data">
                      <span>{{ getFieldTrad(data.value) }}</span>
                    </template>
                    <template #cell(value)="data">
                      <span v-if="data.item.field === 'NameScore'">{{ getResultText(data.value) }}</span>
                      <span v-else-if="data.item.field === 'CreationDateRp2'">{{ getDate(data.value) }}</span>
                      <span v-else>{{ data.value }}</span>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row class="form-group" v-else>
                <b-col sm="4" class="mb-5" v-if="Tracking.CreationDateRp2 !== '' && type != 'DDD' && flagCACP">
                  <form-read-group-label-input
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.creation_date_response_2_ddd') :$t('tracking.creation_date_response_2')" :inputValue="getDate(Tracking.CreationDateRp2)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Response2CreationDate !== ''">
                  <form-read-group-label-input
                    :inputLabel="type === 'DDD' && flagCACP ?$t('tracking.creation_date_response_1_ddd') :$t('tracking.creation_date_response_1')" :inputValue="getDate(Tracking.Response2CreationDate)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="flagCACP && type === 'DDV'">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.flagCACP.demande_status')" :inputValue="Tracking.TechStatusCode !== '' ? translateTechStatusCode(Tracking.TechStatusCode) : $t('common.monitoring.success')">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.IdScore !== '' && type === 'DDV' && !flagCACP">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.id_score')" :inputValue="getResultText(Tracking.IdScore)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.NameScore !== '' && type === 'DDV' && !flagCACP">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.name_score')" :inputValue="getResultText(Tracking.NameScore)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV' && flagCACP">
                  <form-read-group-label-input v-if="Tracking.IdScore !== ''"
                    :inputLabel="$t('tracking.flagCACP.check_result')" :inputValue="getResultText(Tracking.IdScore)">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else-if="Tracking.NameScore !== ''"
                    :inputLabel="$t('tracking.flagCACP.check_result')" :inputValue="getResultText(Tracking.NameScore)">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('tracking.flagCACP.check_result')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV' && flagCACP">
                  <form-read-group-label-input v-if="Tracking.ReasonCode !== ''"
                    :inputLabel="$t('tracking.flagCACP.reason_code_optional')" :inputValue="$t('tracking.flagCACP.reason_code_optional_list.' + Tracking.ReasonCode)">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('tracking.flagCACP.reason_code_optional')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV' && flagCACP">
                  <form-read-group-label-input v-if="Tracking.IdScore2 !== ''"
                    :inputLabel="$t('tracking.flagCACP.check_result_entity')" :inputValue="getResultText(Tracking.IdScore2)">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else-if="Tracking.NameScore2 !== ''"
                    :inputLabel="$t('tracking.flagCACP.check_result_entity')" :inputValue="getResultText(Tracking.NameScore2)">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('tracking.flagCACP.check_result_entity')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV' && flagCACP">
                  <form-read-group-label-input v-if="Tracking.ReasonCodeEntity !== ''"
                    :inputLabel="$t('tracking.flagCACP.reason_code_optional_entity')" :inputValue="$t('tracking.flagCACP.reason_code_optional_entity_list.' + Tracking.ReasonCodeEntity)">
                  </form-read-group-label-input>
                  <form-read-group-label-input v-else
                    :inputLabel="$t('tracking.flagCACP.reason_code_optional_entity')" :inputValue="'-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV' && flagCACP">
                  <form-read-group-label-input
                    :inputLabel="$t('common.response_time')" :inputValue="Tracking ? getDuration(Tracking) : '-'">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.RealName !== '' && type === 'DDV' && !flagCACP">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.real_name')" :inputValue="Tracking.RealName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="type === 'DDV' && flagCACP">
                </b-col>
              </b-row>
              <b-row class="form-group" v-if="type == 'DDD' && (Tracking.LastName !== '' || Tracking.BirthName !== '' || Tracking.FirstName !== '' || Tracking.MarriedName !== '')">
                <b-col sm="4" class="mb-5" v-if="Tracking.FirstName !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.first_name')" :inputValue="Tracking.FirstName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.LastName !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.last_name')" :inputValue="Tracking.LastName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.BirthName !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.birth_name')" :inputValue="Tracking.BirthName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.MarriedName !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.married_name')" :inputValue="Tracking.MarriedName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.FirstName2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.first_name')" :inputValue="Tracking.FirstName2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.LastName2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.last_name')" :inputValue="Tracking.LastName2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.BirthName2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.birth_name')" :inputValue="Tracking.BirthName2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.MarriedName2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.married_name')" :inputValue="Tracking.MarriedName2">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row class="form-group" v-if="type === 'DDD' && (Tracking.CompanyName !== '' ||  Tracking.Siren !== '' ||  Tracking.Siret !== '' ||  Tracking.TVAIntracomm !== '')">
                <b-col sm="4" class="mb-5" v-if="Tracking.CompanyName !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.company_name')" :inputValue="Tracking.CompanyName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.TradingName !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('annuaire.trading_name')" :inputValue="Tracking.TradingName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Siren !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.siren')" :inputValue="Tracking.Siren">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Siret !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.siret')" :inputValue="Tracking.Siret">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.TVAIntracomm !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.tva_intracomm')" :inputValue="Tracking.TVAIntracomm">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.LEI !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.select.identifiers.LEIC.label')" :inputValue="Tracking.LEI">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.EUID !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.select.identifiers.EUID.label')" :inputValue="Tracking.EUID">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.CompanyName2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.company_name')" :inputValue="Tracking.CompanyName2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.TradingName2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('annuaire.trading_name')" :inputValue="Tracking.TradingName2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Siren2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.siren')" :inputValue="Tracking.Siren2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Siret2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.siret')" :inputValue="Tracking.Siret2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.TVAIntracomm2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.tva_intracomm')" :inputValue="Tracking.TVAIntracomm2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.LEI2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.select.identifiers.LEIC.label')" :inputValue="Tracking.LEI2">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.EUID2 !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                      :inputLabel="$t('tracking.select.identifiers.EUID.label')" :inputValue="Tracking.EUID2">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row class="form-group" v-if="type === 'DDD' && Tracking.Status === '0' &&  (Tracking.ReasonCode !== '' ||  Tracking.ReasonDescription !== '')">
                <b-col sm="4" class="mb-5" v-if="Tracking.ReasonCode !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.reason_code')" :inputValue="Tracking.ReasonCode">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.ReasonDescription !== '' && (type === 'DDD'&& !flagCACP)">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.reason_description')" :inputValue="Tracking.ReasonDescription">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
          </div>
          <hr class="mx-auto" />
          <div>
            <form-accordion :title="$t('tracking.history')" :isTitleUpperCase="false">
              <table class="table table-striped" v-if="Tracking.History && Tracking.History.length" :aria-label="$t('tracking.history_table')">
                <caption class="sr-only">{{ $t('tracking.history_caption') }}</caption>
                <thead>
                  <tr>
                    <th scope="col" class="text-center w-25">
                      {{ $t('tracking.status') }}
                    </th>
                    <th scope="col" class="text-center w-25">
                      {{ $t('tracking.status_code') }}
                    </th>
                    <th scope="col" class="text-center w-25">
                      {{ $t('tracking.processing_date') }}
                    </th>
                    <th scope="col" class="text-center w-25">
                      {{ $t('common.actions') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="history in Tracking.History" :key="history.id">
                    <td class="text-center w-25">
                      <div v-if="history.Status !== ''">{{ $t('tracking.status-' + history.Status) }}</div>
                    </td>
                    <td class="text-center w-25">
                      <div v-if="history.StatusCode !== ''">{{ translateTechStatusCode(history.StatusCode) }}</div>
                    </td>
                    <td class="text-center w-25">
                      {{ getDate(history.DateTime) }}
                    </td>
                    <td class="text-center align-middle w-25">
                      <div class="d-flex justify-content-center align-item-center" v-if="history.Status === '1' || history.Status === '10' || history.Status === '30' || history.Status === '45' || history.Status === '50'
                       || history.Status === '100' || history.Status === '110' || history.Status === '125' || history.Status === '160'">
                        <button type="button" class="btn btn-link p-0 mr-2" @click="seeJson(history.IdMsg, 'historyTracking', 'see')" :aria-label="$t('common.view_details')">
                          <i class="fa fa-eye color-var-actionButtonColorBlue" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="btn btn-link p-0" @click="seeJson(history.IdMsg, 'historyTracking', 'download')" :aria-label="$t('common.download')">
                          <i class="fa fa-download color-var-actionButtonColorBlue" aria-hidden="true"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </form-accordion>
          </div>

        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import AppButton from '@/components/common/AppButton.vue'
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue";
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue";
import {errorMessageAlert} from "@/helpers/alert";
import { downloadFileWithDefinedHeaders } from '@/helpers/download'
import {loadPage} from '@/helpers/routing'
import moment from "moment-timezone";
import {DOMParser} from "xmldom";
import alpha2Country from "../../data/alpha2Country.json"
import conf from "@/config/config.dev";

export default {
  name: 'TrackingDetails',
  components: {
    FormReadGroupLabelInput,
    'page-outline': PageOutline,
    'app-button': AppButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
  },
  computed: {
    canUserDelete () {
      return this.$engine.get(this.engineIndex).rights.rightIs('usercompany_delete', true) || this.$engine.get(this.engineIndex).rights.rightIs('usercompany_delete_admin', true)
    },
    canUserEdit () {
      return this.$engine.get(this.engineIndex).rights.rightIs('usercompany_edit', true) || this.$engine.get(this.engineIndex).rights.rightIs('usercompany_edit_admin', true)
    },
    listTitle () {
      return this.$t('tracking.tracks_details')
    },
    TrackingTableFormattedData () {
      return this.TOOLBOXTableFieldsOrder.map((key) => ({
       field: key,
       value: this.Tracking[key]
     })).filter(elem => !!elem.value)
   },
   TrackingTestCaseTableFormattedData () {
     return this.TOOLBOXTableTestCaseFieldsOrder.map((key) => ({
      field: key,
      value: this.Tracking[key]
    })).filter(elem => !!elem.value)
   },
   TrackingTableRespFormattedData () {
     return this.TOOLBOXTableResponseFieldsOrder.map((key) => ({
      field: key,
      value: this.Tracking[key]
    })).filter(elem => !!elem.value)
   }
  },
  props: ['engineIndex', 'id', 'type'],
  data () {
    return {
      timezone: '+00:00',
      flagCACP: conf.visual === 'CACP',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      activateSpinner: false,
      countries: alpha2Country.countries.reverse(),
      TOOLBOXTableFieldsOrder: ['Reference', 'IBAN', 'FullName', 'LEI', 'BIC', 'Identifier', 'CreationDateRq1'],
      TOOLBOXTableTestCaseFieldsOrder: ['TestCasename', 'TestCaseStatus'],
      TOOLBOXTableResponseFieldsOrder: ['CreationDateRp2', 'NameScore'],
      TOOLBOXTableFields: [
        { key: 'field', label: '', class: 'text-left', sortable: false },
        { key: 'value', label: '', class: 'text-left', sortable: false },
      ],
      returnUrl: '',
      resultMatchingOptions: [
        { id: "NOAP", text: "Not Applicable" },
        { id: "MTCH", text: "Match" },
        { id: "NMTC", text: "No Match" },
        { id: "CMTC", text: "Close Match" },
        { id: "NULL", text: this.$t('tracking.no_result') }
      ],
      Tracking: {}
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    
    this.idTrackingBulk = this.$route.query.idTrackingBulk
    this.defineReturnURL()
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'utilisateur',
      // returnUrl: ''
    })

    this.$engine.get(this.engineIndex).settings.set({msgDirection: this.direction})
    this.getTrack()
    this.$f7.initPullToRefresh()
    this.pageCounter = 0


    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    getFieldTrad (field) {
      switch (field) {
        case 'IBAN':
          return this.$t('tracking.iban')
        case 'Identifier':
          return this.$t('tracking.identifier')
        case 'Reference':
          return this.$t('tracking.reference')
        case 'CreationDateRq1':
          return this.$t('common.dt')
        case 'TestCasename':
          return this.$t('tracking.testcase_name')
        case 'TestCaseStatus':
          return this.$t('tracking.testcase_status')
        case 'NameScore':
          return this.$t('tracking.name_score')
        case 'CreationDateRp2':
          return this.$t('common.dt')
        case 'LEI':
          return this.$t('tracking.select.identifiers.LEIC.label')
        case 'BIC':
          return this.$t('tracking.bic')
        default:
          return field
      }
    },
    getInputLabel() {
      if (this.flagCACP) {
        if (this.type === 'DDD') {
          return this.$t('tracking.message_id_ddd')
        } else if (this.type === 'DDV') {
          return this.$t('tracking.flagCACP.entity_request_id_2')
        }
      }
      return this.$t('tracking.id_track')
    },
    isXML (str) {
      try {
        const parser = new DOMParser()
        const jsonDoc = parser.parseFromString(str, 'text/xml')
        return jsonDoc.documentElement.nodeName !== 'parsererror'
      } catch (e) {
        return false
      }
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    isCSV(str) {
      const lines = str.split('\n')
      return lines.length > 1 && lines[0].includes(';')
    },
    seeJson (IdMsg, service, action) {
      let that = this
      const id = IdMsg
      const Type = this.type
      let dataDetails = {}
      this.$engine.get(this.engineIndex).tracking.getJSON({service, id, Type})
      .then((resp) => {
        if (resp.data) {
          dataDetails.data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
          dataDetails.type = service
          if (action === 'see') {
            that.$bus.emit('popup-json-details', dataDetails)
          } else {
            //download file
            let data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
            if (this.isXML(data)){
              const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.xml'
              const blob = new Blob([data], { type: 'text/xml' })

              downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
              that.$f7.alert('', that.$i18n.t('common.xml_downloaded'))
            }
            if (this.isJSON(data)){
              const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.json'
              const blob = new Blob([data], { type: 'application/json' })

              downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
              that.$f7.alert('', that.$i18n.t('common.json_downloaded'))
            }
            if (this.isCSV(data)){
              const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.csv'
              const blob = new Blob([data], { type: 'text/csv' })

              downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
              that.$f7.alert('', that.$i18n.t('common.csv_downloaded'))
            }
          }
        }
      })
      .catch((error) => {
        errorMessageAlert(error, that)
      })
    },
    getDateDay (date){
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    getDate (date){
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    getResultText (id) {
      const option = this.resultMatchingOptions.find(opt => opt.id === id)
      return option ? option.text : '-'
    },
    translateTechStatusCode (code) {
      if (this.$t('tracking.error-status.' + code) !== 'tracking.error-status.' + code) {
        return this.$t('tracking.error-status.' + code)
      } else {
        return this.$t('tracking.error-status.default', { statusCode: code })
      }

    },
    defineReturnURL() {
      let that = this
      let type = parseInt(this.type, 10)
      if (!isNaN(type) && this.type == type){
        this.returnUrl =  '/tracking/BULKDETAILS/'+ this.type
      }else{
        if (this.idTrackingBulk !== undefined) {
          this.returnUrl = '/trackingbulk/' + this.idTrackingBulk
        }
        else {
          this.returnUrl =  '/tracking/'+ this.type+'/NULL'
        }
      }
    },
    getCountryFromIBAN(iban) {
      if (!iban || typeof iban !== 'string' || iban.length < 2) {
        return this.$t('countriesAlpha2Code.UNKNOWN')
      }

      const countryCode = iban.substring(0, 2).toUpperCase()

      if (!this.countries.includes(countryCode)) {
        return this.$t('countriesAlpha2Code.UNKNOWN')
      }

      return this.$t(`countriesAlpha2Code.${countryCode}`) || this.$t('countriesAlpha2Code.UNKNOWN')
    },
    getTrack () {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.get(this.engineIndex).usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        Type: this.type,
        IdTrack: this.id
      }
      that.$engine.get(this.engineIndex).tracking.getTracks(
        filterConditions
      )
      .then(resp => {
        let requests = {}
        if (resp.data && resp.data.tracks && resp.data.tracks.length) {
          that.Tracking = resp.data.tracks[0]
        }
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getResultDDD(item) {
      if ((item.ReasonCode == '') && (item.TechStatusCode == '')) {
        return this.$t('tracking.result.account_open')
      }


      if (item.TechStatusCode == 'STRM-CURL-28') {
        return this.$t('tracking.result.timeout')
      }

      if (item.TechStatusCode != '') {
        return this.$t('tracking.result.error')
      }

      switch (item.ReasonCode) {
        case '9201':
          return this.$t('tracking.result.account_close')
        case '9202':
          return this.$t('tracking.result.no_account')
        case '9203':
          return this.$t('tracking.result.other')
      }

    },
    getDuration (item) {
      if (item.CreationDateRq1 !== '' && item.Response2CreationDate !== '') {
        const start = moment(item.CreationDateRq1)
        const end = moment(item.Response2CreationDate)

        return end.diff(start, 'milliseconds') + ' ms'
      }
      else {
        return '-'
      }
    },
    hasProfileTrad (profileName) {
      let trad = this.$i18n.t('rights.db_profiles.' + profileName)
      if (trad === ('rights.db_profiles.' + profileName)) {
        return profileName
      }
      return trad
    },
    goBack () {
      this.$f7.mainView.router.back()
    }
  }
}
</script>
